import { InjectionToken } from '@angular/core';
import { IImageryConfig } from './model/iimagery-config';

export const ConfigurationToken: InjectionToken<IImageryConfig> = new InjectionToken('imagery-map-component-config');



// WEBPACK FOOTER //
// C:/Users/user/projects/ansyn/src/app/packages/imagery/configuration.token.ts